<script setup>
import { onBeforeUnmount } from 'vue';
import ToastList from '@acs/components-library/src/components/common/ToastList.vue';
import { useToastStore } from '../../store/toastStore.js';

const toastStore = useToastStore();

const handleGlobalMessage = (event) => {
  if (event.data.to !== 'app') {
    return;
  }
  const message = event.data.message || event.data.error?.message;
  const color = event.data.color || (event.data.error ? 'error' : 'warning');
  toastStore.showToast(message, { color: color });
};

window.addEventListener('message', handleGlobalMessage);

onBeforeUnmount(() => {
  window.removeEventListener('message', handleGlobalMessage);
});

</script>

<template>
  <ToastList
    :toasts="toastStore.toasts"
    @remove-toast="(t) => toastStore.removeToast(t)"
  />
</template>

